import { render, staticRenderFns } from "./EnrollmentBehavior.vue?vue&type=template&id=2eb1fecd&scoped=true&"
import script from "./EnrollmentBehavior.vue?vue&type=script&lang=js&"
export * from "./EnrollmentBehavior.vue?vue&type=script&lang=js&"
import style0 from "./EnrollmentBehavior.vue?vue&type=style&index=0&id=2eb1fecd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb1fecd",
  null
  
)

export default component.exports